// extracted by mini-css-extract-plugin
export default {"Uploading":"Uploading___hg_W0"};